<template>
  <transition mode="out-in" :name="transitionName">
    <div
      v-bind:style="{ color: activeColor }"
      class="h-32 text-6xl font-light text-center"
      :key="activeIndex"
    >
      {{ titles[activeIndex] }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      titles: ["software developer", "ux admirer", "outdoors enthusiast", "tech nerd", ],
      activeIndex: 0,
      colors: [
        "#E06C75",
        "#98C379",
        "#E5C07B",
        "#61AFEF",
        "#C678DD",
        "#56B6C2",
      ],
      activeColor: "#E06C75",
      transitionName: "slide-right",
    };
  },
  mounted() {
    setInterval(this.changeTitle, 5000);
  },
  methods: {
    changeTitle() {
      let eligibleColors = this.colors.filter(
        (color) => color !== this.activeColor
      );

      this.activeColor =
        eligibleColors[Math.floor(Math.random() * eligibleColors.length)];

      this.transitionName = this.randomTransition();

      this.activeIndex =
        this.activeIndex == this.titles.length - 1 ? 0 : this.activeIndex + 1;
    },
    randomTransition() {
      if (Math.random() > 0.5) {
        return "slide-right";
      } else {
        return "slide-down";
      }
    },
  },
};
</script>

<style scoped>
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 1.25s ease-in-out;
}

.slide-right-leave-to {
  transform: translateX(100%);
  transform-origin: center top;
  transform-style: preserve-3d;
  opacity: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  transform-origin: center bottom;
  transform-style: preserve-3d;
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s ease-in-out;
}

.slide-down-enter {
  transform: translateY(-100%);
  transform-origin: center-top;
  transform-style: preserve-3d;
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(100%);
  transform-origin: center-top;
  transform-style: preserve-3d;
  opacity: 0;
}
</style>